import React from "react";
import { Pagination } from "react-bootstrap";
import "./style.scss";
import { useAppSelector } from "@/redux-config/hooks";
import { selectLanguage } from "@/redux-config/entities/language";
import { ConvertNumber } from "@/utils";

export const CustomPagination: React.FC<{
  total: number;
  perPage: number;
  currentPage: number;
  changePage: Function;
}> = ({ total, perPage, currentPage, changePage }) => {
  let maxSize = Math.ceil(total / perPage);
  const lang = useAppSelector(selectLanguage);
  return (
    <div className="d-flex flex-row align-items-center justify-content-center mt-3">
      <div className="d-flex flex-row">
        <Pagination.Prev
          onClick={() => {
            if (+currentPage > 1) {
              changePage(+currentPage - 1);
            }
          }}
          className={"bg-custom-light"}
        />
        {+currentPage != 1 && (
          <Pagination.Item
            onClick={() => {
              changePage(1);
            }}
          >
            {ConvertNumber("1", lang, false)}
          </Pagination.Item>
        )}
        {3 < +currentPage && <Pagination.Ellipsis disabled />}
        {+currentPage - 1 > 1 && (
          <Pagination.Item
            onClick={() => {
              changePage(+currentPage - 1);
            }}
          >
            {ConvertNumber(+currentPage - 1 + "", lang, false)}
          </Pagination.Item>
        )}
        <Pagination.Item active>
          {ConvertNumber(currentPage + "", lang, false)}
        </Pagination.Item>
        {+currentPage + 1 < maxSize && (
          <Pagination.Item
            onClick={() => {
              changePage(+currentPage + 1);
            }}
          >
            {ConvertNumber(+currentPage + 1 + "", lang, false)}
          </Pagination.Item>
        )}
        {+currentPage + 2 < maxSize && <Pagination.Ellipsis disabled />}
        {maxSize > 1 && +currentPage != maxSize && (
          <Pagination.Item
            onClick={() => {
              changePage(maxSize);
            }}
          >
            {ConvertNumber(+maxSize + "", lang, false)}
          </Pagination.Item>
        )}
        <Pagination.Next
          onClick={() => {
            if (+currentPage < maxSize) {
              changePage(+currentPage + 1);
            }
          }}
          className={"bg-custom-light"}
        />
      </div>
    </div>
  );
};